import { render, staticRenderFns } from "./lottery-marquee.vue?vue&type=template&id=1abbf18d&scoped=true&lang=pug&"
import script from "./lottery-marquee.vue?vue&type=script&lang=js&"
export * from "./lottery-marquee.vue?vue&type=script&lang=js&"
import style0 from "./lottery-marquee.vue?vue&type=style&index=0&id=1abbf18d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abbf18d",
  null
  
)

export default component.exports